import React from "react";
import { Helmet } from "react-helmet-async";

type SEOProps = {
  title: string;
  description?: string;
  canonicalPath?: string; // np. "/blog/umowa-adopcyjna.html"
  ogImagePath?: string;   // np. "/Photo.png"
};

const SITE_URL = "https://pienkowskilegal.pl";

function toAbsoluteUrl(path: string) {
  if (!path) return SITE_URL;
  if (path.startsWith("http://") || path.startsWith("https://")) return path;
  if (!path.startsWith("/")) return `${SITE_URL}/${path}`;
  return `${SITE_URL}${path}`;
}

export default function SEO({
  title,
  description,
  canonicalPath,
  ogImagePath = "/Photo.png",
}: SEOProps) {
  // canonicalPath powinien być stabilny (bez # i bez parametrów)
  const canonical = canonicalPath ? toAbsoluteUrl(canonicalPath) : SITE_URL;
  const ogImage = toAbsoluteUrl(ogImagePath);

  return (
    <Helmet>
      <title>{title}</title>

      {description ? <meta name="description" content={description} /> : null}

      <link rel="canonical" href={canonical} />

      <meta property="og:title" content={title} />
      {description ? <meta property="og:description" content={description} /> : null}
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="pl_PL" />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description ? <meta name="twitter:description" content={description} /> : null}
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}